<template>
    <div class="historyListWrap">
      <history-item
        v-for="(historyItem) in historyItemList"
        :key="historyItem.num"
        :historyItem="historyItem"
      />
    </div>

</template>

<script>
    import HistoryItem from '@/components/menu/Sunnyfactory/HistoryItem'
    import { mapGetters } from 'vuex'

    export default {
        name: "history-item-list",
        components : {
          "history-item" : HistoryItem,
        },
        /*props : ['historyItemList'],*/
        computed : {
          ...mapGetters({
            historyItemList : 'historyStore/getHistories'
          })
        },
        data () {
          return {
          }
        },
        created () {

        }
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/HistoryItemList.vue